
export default {
  install(Vue, options) {
    Vue.config.globalProperties.$setTitle = function (title) {
      document.title = title;
      // 如果是 iOS WebView，可能需要触发一次页面重绘
      if (navigator.userAgent.includes('iPhone')) {
        const iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        iframe.onload = () => {
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 10);
        };
        document.body.appendChild(iframe);
      }
    };
  }
};